import type * as Types from '@shared/types/graphqlGenerated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type FsAnalyticsEnvironmentSharedQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FsAnalyticsEnvironmentSharedQuery = { analyticsEnvironment: string };


export const FsAnalyticsEnvironmentSharedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FsAnalyticsEnvironment_Shared_Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyticsEnvironment"}}]}}]} as unknown as DocumentNode;
export type FsAnalyticsEnvironmentSharedQueryQueryResult = Apollo.QueryResult<FsAnalyticsEnvironmentSharedQuery, FsAnalyticsEnvironmentSharedQueryVariables>;

export function useFsAnalyticsEnvironmentSharedQuery(
  baseOptions?: Apollo.QueryHookOptions<FsAnalyticsEnvironmentSharedQuery, FsAnalyticsEnvironmentSharedQueryVariables>
) {
  return Apollo.useQuery<FsAnalyticsEnvironmentSharedQuery, FsAnalyticsEnvironmentSharedQueryVariables>(
    FsAnalyticsEnvironmentSharedQueryDocument,
    baseOptions
  );
}

export function useFsAnalyticsEnvironmentSharedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FsAnalyticsEnvironmentSharedQuery, FsAnalyticsEnvironmentSharedQueryVariables>) {
  return Apollo.useLazyQuery<FsAnalyticsEnvironmentSharedQuery, FsAnalyticsEnvironmentSharedQueryVariables>(
    FsAnalyticsEnvironmentSharedQueryDocument,
    baseOptions
  );
}

export function useFsAnalyticsEnvironmentSharedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FsAnalyticsEnvironmentSharedQuery, FsAnalyticsEnvironmentSharedQueryVariables>) {
  return Apollo.useSuspenseQuery<FsAnalyticsEnvironmentSharedQuery, FsAnalyticsEnvironmentSharedQueryVariables>(
    FsAnalyticsEnvironmentSharedQueryDocument,
    baseOptions
  );
}
